import { call } from '../@';

const requestPayment = (propertyId: string) => call('payment-request', { propertyId });

export default requestPayment;
